// extracted by mini-css-extract-plugin
export default {"status":"Mf8UyjAmjM","endpoints":"xiQl5UBs40"};